<template>
  <div
    v-show="hiddenWarnings > 0 || hiddenIncidents > 0"
    class="flex flex-col items-center gap-2 rounded-lg bg-grey-15 px-6 py-4 text-sm text-type-secondary"
  >
    <div v-if="hazardsStore.activeView === HazardView.Both" class="flex flex-col items-center">
      <div class="text-center">
        There {{ hiddenWarnings + hiddenIncidents === 1 ? 'is' : 'are' }} <span class="font-bold">{{ hiddenText }}</span> outside of your
        current map view and/or filters.
      </div>
      <button class="cursor-pointer text-indigo-500 hover:underline" @click="zoomOutToState">Zoom out to the whole state</button>
    </div>
    <div v-else-if="hazardsStore.activeView === HazardView.List" class="flex flex-col items-center">
      <div class="text-center">
        There {{ hiddenWarnings + hiddenIncidents === 1 ? 'is' : 'are' }} <span class="font-bold">{{ hiddenText }}</span> outside of your
        current list view.
      </div>
      <gv-type class="cursor-pointer !text-indigo-500 hover:underline" @click="viewTheWholeState">View the whole state</gv-type>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { HazardView, useHazardsStore, useMapStore, WESTERN_AUSTRALIA_BOUNDING_BOX } from '@/features/hazards';

const props = defineProps<{
  hiddenWarnings: number;
  hiddenIncidents: number;
}>();

const map = useMapStore();
const hazardsStore = useHazardsStore();

const hiddenText = computed(() => {
  const hiddenWarnings = props.hiddenWarnings;
  const hiddenIncidents = props.hiddenIncidents;

  const warningText = hiddenWarnings === 1 ? '1 warning' : `${hiddenWarnings} warnings`;
  const incidentText = hiddenIncidents === 1 ? '1 incident' : `${hiddenIncidents} incidents`;

  if (!!hiddenWarnings && !!hiddenIncidents) {
    return `${warningText} & ${incidentText}`;
  }

  if (hiddenWarnings) {
    return warningText;
  }

  return incidentText;
});

const zoomOutToState = () => {
  map.setViewPort(WESTERN_AUSTRALIA_BOUNDING_BOX);
};

const viewTheWholeState = () => {
  zoomOutToState();
  map.setVisibleHazards();
};
</script>
